import { rtkApi } from '@/apis/rtkApi';

export interface RefinanceRateAlert {
  _id: string;
  userId: string;
  propertyId: string;
  threshold: number;
  /** When set, alert compares market to current mortgage rate − spreadBps. */
  currentRatePct?: number | null;
  spreadBps?: number | null;
  loanProgram: string;
  enabled: boolean;
  lastTriggeredAt?: string | null;
  lastTriggeredRate?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface UpsertRateAlertBody {
  threshold?: number;
  currentRatePct?: number | null;
  spreadBps?: number;
  loanProgram?: string;
  enabled?: boolean;
}

interface RateAlertResponse {
  success: boolean;
  data: RefinanceRateAlert;
  message?: string;
}

interface RateAlertListResponse {
  success: boolean;
  data: RefinanceRateAlert[];
  message?: string;
}

export const rateAlertApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getRateAlerts: builder.query<RefinanceRateAlert[], void>({
      query: () => ({ url: `/rate-alerts` }),
      transformResponse: (response: RateAlertListResponse) =>
        response?.data ?? [],
      providesTags: ['RateAlerts'],
    }),
    upsertRateAlert: builder.mutation<
      RefinanceRateAlert,
      { propertyId: string } & UpsertRateAlertBody
    >({
      query: ({ propertyId, ...body }) => ({
        url: `/rate-alerts/${encodeURIComponent(propertyId)}`,
        method: 'PUT',
        data: body,
      }),
      transformResponse: (response: RateAlertResponse) => response.data,
      invalidatesTags: ['RateAlerts'],
    }),
    deleteRateAlert: builder.mutation<RefinanceRateAlert, string>({
      query: (propertyId) => ({
        url: `/rate-alerts/${encodeURIComponent(propertyId)}`,
        method: 'DELETE',
      }),
      transformResponse: (response: RateAlertResponse) => response.data,
      invalidatesTags: ['RateAlerts'],
    }),
  }),
});

export const {
  useGetRateAlertsQuery,
  useUpsertRateAlertMutation,
  useDeleteRateAlertMutation,
} = rateAlertApi;
